import { exception, information } from '@/appinsights/logging/ApplicationInsightLog';

/***** private methods *****************/
/**
 * @returns true if open in App, else false
 */
export const isApp = (): boolean => {
	if (location.href.includes('client=app')) {
		return true;
	}

	if ((<any>window).nsWebViewBridge !== undefined) {
		return true;
	}
	return false;
};
export const isWeb = (): boolean => {
	return !isApp();
};

const isDevelop_ = () => {
	return (
		location.href.startsWith('https://localhost') ||
		location.href.startsWith('https://alpha.') ||
		location.href.startsWith('https://alpha-') ||
		location.href.startsWith('https://sit-') ||
		location.href.startsWith('https://prep.') ||
		location.href.startsWith('https://prep-') ||
		location.href.startsWith('https://preprod-')
	);
};

const isLocalhost_ = () => {
	return location.href.startsWith('https://localhost');
};

/***** public *****************/
export const isExternalLink = (routePath): boolean => {
	return routePath && (routePath.startsWith('//') || routePath.toLocaleLowerCase().startsWith('https'));
};

/**
 * Sends a message to the app via gotMessage
 * @param message An object containing the message: { 'MAIN_TITLE': 'title'}
 *
 */
export const AppSendMessage = (message) => {
	if (message && isApp()) {
		(<any>window).nsWebViewBridge?.emit('gotMessage', message);
		if (!(<any>window).nsWebViewBridge) {
			information('App_message', message);
		}
	}
};

export const browserIe11OrOlder = () => {
	let bool = false;
	if (navigator.userAgent.includes('MSIE') || (<any>navigator).appVersion.includes('Trident/')) {
		bool = true;
	}
	return bool;
};

export const setPageMetaData = (model: any) => {
	try {
		if (!model) {
			return;
		}
		document.title = model.metaTitle ?? document.title;

		const metaData = [
			{
				type: 'description',
				value: model.metaDescription ?? '',
				property: 'name',
			},
			{ type: 'keywords', value: model.metaKeywords ?? '', property: 'name' },
		];
		updateMetaTags(metaData);
	} catch (e) {
		exception(e);
		// too bad
	}
};

export const setSoMe = () => {
	try {
		const metaData = [
			{ type: 'og:type', value: 'website', property: 'name' },
			{ type: 'og.url', value: location.origin, property: 'name' },
			{
				type: 'og:image',
				value: '/alm.-brand/alm.-brand-media/images-jpg/private/insurance/couple-sofa.jpg',
				property: 'property',
			},
			{ type: 'og:image:width', value: '1716', property: 'property' },
			{ type: 'og:image:height', value: '1100', property: 'property' },
			{ type: 'og:image:alt', value: 'Alm. Brand', property: 'property' },
			{
				type: 'og:description',
				value: 'Forsikringer til dig og dine behov. Vi d&#xE6;kker familier, virksomheder og landbrug i alle st&#xF8;rrelser. V&#xE6;lg dine d&#xE6;kninger og beregn din pris online.',
				property: 'property',
			},
			{
				type: 'og:title',
				value: 'Forsikringer, der passer til dig | Alm. Brand',
				property: 'property',
			},
			{ type: 'og:site_name', value: 'Alm. Brand', property: 'property' },
		];
		updateMetaTags(metaData);
	} catch (e) {
		exception(e);
		// too bad
	}
};

const updateMetaTags = (metaData) => {
	metaData.forEach((meta) => {
		const metaTag = document.querySelector(`meta[${meta.property}="${meta.type}"]`);

		if (metaTag) {
			metaTag.setAttribute('content', meta.value);
		} else {
			const tag = document.createElement('meta');
			tag.setAttribute(meta.property, meta.type);
			tag.setAttribute('content', meta.value);
			document.head.appendChild(tag);
		}
	});
};

export const getDevice = (): string => {
	try {
		let appMode = isApp() ? 'App' : 'Web';
		if (appMode === 'Web') {
			// navigator.userAgentData.mobile is experimental
			if ((navigator as any)?.userAgentData?.mobile || /(iPod|iPhone|iPad)/.exec(navigator?.userAgent)) {
				appMode = 'Mobile';
			}
		}
		return appMode;
	} catch (e) {
		return 'Unknown platform';
	}
};

export const logToUi = (msg: unknown, doLog = false) => {
	if (!isDevelop || !doLog) {
		return;
	}
	const logger = document.getElementById('logger');
	if (!logger) {
		const div = document.createElement('div');
		// set style
		div.style.border = '2px solid red';
		div.id = 'logger';
		document.body.prepend(div);
	}
	const logElem = document.getElementById('logger');

	if (typeof msg == 'object') {
		logElem.innerHTML += JSON.stringify(msg) + '<br />';
	} else {
		logElem.innerHTML += msg + '<br />';
	}
};

export const isValidDomain = (domain: string): boolean => {
	return (
		domain?.startsWith('https://beregn.almbrand.dk') ||
		domain?.startsWith('https://localhost') ||
		domain?.startsWith('https://alpha.') ||
		domain?.startsWith('https://alpha-') ||
		domain?.startsWith('https://sit-') ||
		domain?.startsWith('https://prep.') ||
		domain?.startsWith('https://prep-') ||
		domain?.startsWith('https://preprod-')
	);
};
export const isDevelop = isDevelop_();
export const isLocalHost = isLocalhost_();
